import { AxiosRequestConfig } from 'axios';

import { HttpClient } from '@zeta-core';
import {
  APIResponse,
  IChunkedUploadChunkResponse,
  IChunkedUploadMergeRequest,
  IChunkedUploadMergeResponse,
  IChunkedUploadPresignRequest,
  IChunkedUploadPresignResponse,
  IChunkedUploadSessionRequest,
  IChunkedUploadSessionResponse,
  IChunkedUploadStatusRequest,
  IChunkedUploadStatusResponse,
  IChunkedUploadCompleteRequest,
  IChunkedUploadCompleteResponse,
  IDownloadEmailContentRequest,
  IDownloadEmailContentResponse,
  IEmptyRequestResponse,
  IProcessEmailAttachmentRequest,
  ITranscriptDownloadRequest,
  ITranscriptDownloadResponse,
  ITranscriptUploadRequest,
  ITranscriptUploadResponse,
  IViewByIDTranscriptRequest,
  IViewByIDTranscriptResponse,
  IViewTranscriptRequest,
  IViewTranscriptResponse,
} from '@zeta-types';
import { TRANSCRIPT_SERVICE } from '../services-path';

export const TranscriptAPIs = () => {
  return {
    uploadTranscript: (
      payload: ITranscriptUploadRequest,
      config: AxiosRequestConfig = {},
    ): APIResponse<ITranscriptUploadResponse> =>
      HttpClient.upload(`${TRANSCRIPT_SERVICE}/transcript/upload`, payload, {
        // Override default Axios timeout (2 minutes) to 10 minutes for this API only
        timeout: 60000000, // 1000 minutes
        ...config,
      }),

    downloadTranscript: (payload: ITranscriptDownloadRequest): APIResponse<ITranscriptDownloadResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/download`, payload),

    viewTranscript: (payload: IViewTranscriptRequest): APIResponse<IViewTranscriptResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/view/topicsummary`, payload),

    streamTranscript: (payload: FormData): APIResponse<Blob> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/stream`, payload, { headers: { Range: 'bytes=0-' }, responseType: 'blob' }),

    viewTranscriptByID: (payload: IViewByIDTranscriptRequest): APIResponse<IViewByIDTranscriptResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/viewbyid`, payload),

    downloadEmailContent: (payload: IDownloadEmailContentRequest): APIResponse<IDownloadEmailContentResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/email/ff/content/download`, payload),

    downloadEmailAttachment: (payload: IDownloadEmailContentRequest): APIResponse<Blob> =>
      HttpClient.download(`${TRANSCRIPT_SERVICE}/email/ff/content/download`, payload, {}, false, true),

    processEmailAttachment: (payload: IProcessEmailAttachmentRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/email/ff/content/process`, payload),

    reprocessEmailAttachment: (payload: IProcessEmailAttachmentRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/email/attachment/reupload`, payload),

    // Chunked Upload APIs
    createUploadSession: (payload: IChunkedUploadSessionRequest): APIResponse<IChunkedUploadSessionResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/upload/session`, payload),

    uploadChunk: (payload: FormData, config: AxiosRequestConfig = {}): APIResponse<IChunkedUploadChunkResponse> =>
      HttpClient.upload(`${TRANSCRIPT_SERVICE}/transcript/upload/chunk`, payload, {
        timeout: 300000, // 5 minutes per chunk
        ...config,
      }),

    getUploadStatus: (payload: IChunkedUploadStatusRequest): APIResponse<IChunkedUploadStatusResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/upload/status`, payload),

    mergeChunks: (payload: IChunkedUploadMergeRequest): APIResponse<IChunkedUploadMergeResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/upload/merge`, payload),
      
    getPresignedUrls: (payload: IChunkedUploadPresignRequest): APIResponse<IChunkedUploadPresignResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/upload/presign-urls`, payload),

    completeUpload: (payload: IChunkedUploadCompleteRequest): APIResponse<IChunkedUploadCompleteResponse> =>
      HttpClient.post(`${TRANSCRIPT_SERVICE}/transcript/upload/complete`, payload),
  };
};

export * from './uploadService';
export * from './chunkedUploadService';
